export default function getNamespace(): string {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id") ?? null;
  const organisationId = urlParams.get("organisationId") ?? null;
  if (id) {
    return `bookingtool/${id}`;
  } else if (organisationId) {
    return `account/${organisationId}`;
  }
  return "UNKNOWN_NAMESPACE";
}
